module.exports = __webpack_public_path__ + "static/C_ayabrown-4a157a291b89166e5a824f7c6b37fbaa.png";